import { create } from 'zustand';
import type { TarpLevel } from '@/domain';

interface AlertState {
  overall: TarpLevel;
  setOverall: (level: TarpLevel) => void;
}

export const useAlertStore = create<AlertState>((set) => ({
  overall: 'NORMAL',
  setOverall: (level) => set({ overall: level }),
}));
